import {
  SET_CONTENT_COPY_MODAL_ID,
  SET_CONTENT_COPY_MODAL_IS_VISIBLE,
} from './types'

export const state = {
  id: null,
  isVisible: false
}

export const mutations = {
  [SET_CONTENT_COPY_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_CONTENT_COPY_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  }
}

export const actions = {
  openContentCopyModal ({ commit, dispatch }, contentId) {
    dispatch('prepareContentCopyModal')
      .then(() => commit(SET_CONTENT_COPY_MODAL_ID, contentId))
      .then(() => commit(SET_CONTENT_COPY_MODAL_IS_VISIBLE, true))
  },
  closeContentCopyModal ({ commit }) {
    commit(SET_CONTENT_COPY_MODAL_ID, null)
    commit(SET_CONTENT_COPY_MODAL_IS_VISIBLE, false)
  },
  prepareContentCopyModal ({ dispatch }) {
    dispatch('fetchWritableFolders')
  }
}

export const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentCopyModal.js